import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  private readonly authAmplify = inject(AuthAmplifyService);

  ngOnInit(): void {
    this.authAmplify.logout()
  }

}
